module.exports = __webpack_public_path__ + "static/nova-0d3cb3c014d15e765b82a55a30328f98.png";